interface NavbarProps {
  isScrolled: boolean;
}

export default function Navbar({ isScrolled }: NavbarProps) {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-black/80'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        <div className="flex items-center cursor-pointer" onClick={() => scrollToSection('hero')}>
          <span className={`text-lg font-bold tracking-widest ${isScrolled ? 'text-gray-900' : 'text-white'}`} style={{ fontFamily: 'serif' }}>
            RAMEN 鶴
          </span>
        </div>
        <div className="flex items-center gap-8">
          <button
            onClick={() => scrollToSection('menu')}
            className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
              isScrolled ? 'text-gray-800 hover:text-red-800' : 'text-white hover:text-red-300'
            }`}
          >
            メニュー
          </button>
          <button
            onClick={() => scrollToSection('about')}
            className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
              isScrolled ? 'text-gray-800 hover:text-red-800' : 'text-white hover:text-red-300'
            }`}
          >
            こだわり
          </button>
          <button
            onClick={() => scrollToSection('location')}
            className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
              isScrolled ? 'text-gray-800 hover:text-red-800' : 'text-white hover:text-red-300'
            }`}
          >
            店舗情報
          </button>
        </div>
      </div>
    </nav>
  );
}